"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppLayoutMainSidebar = exports.AppLayoutMainContent = exports.AppLayoutMain = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _utils = require("../../utils");

var _composeStencilComponent = require("../../utils/composeStencilComponent");

var _GridContainer = _interopRequireDefault(require("../grid/GridContainer"));

var _GridItem = _interopRequireDefault(require("../grid/GridItem"));

var _constants = require("../grid/constants");

var _Flex = _interopRequireDefault(require("../Flex"));

var _helperComponents = require("./helperComponents");

var _interfaces = require("./interfaces");

var _useAppLayout2 = require("./useAppLayout");

var _core = require("@emotion/core");

var _excluded = ["children", "size"],
    _excluded2 = ["children"],
    _excluded3 = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var AppLayoutMainBase = function AppLayoutMainBase(_ref) {
  var children = _ref.children,
      size = _ref.size,
      contentProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return (0, _core.jsx)(_helperComponents.ContentWrapper, {
    isPositionInitial: true,
    isMainComponent: true,
    size: size,
    contentProps: _objectSpread(_objectSpread({}, contentProps), {}, {
      flexDirection: 'row',
      width: '100%',
      justifyContent: 'flex-start',
      alignItems: 'flex-start'
    })
  }, (0, _core.jsx)(_GridContainer.default, null, children));
};

var AppLayoutMainContentBase = function AppLayoutMainContentBase(_ref2) {
  var children = _ref2.children,
      props = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);

  var _useAppLayout = (0, _useAppLayout2.useAppLayout)(),
      hasSidebar = _useAppLayout.settings.hasSidebar;

  return (0, _core.jsx)(_GridItem.default, (0, _extends2.default)({
    lg: hasSidebar ? 8 : _constants.GRID_COLUMNS.lg,
    md: hasSidebar ? 5 : _constants.GRID_COLUMNS.md,
    sm: _constants.GRID_COLUMNS.sm
  }, (0, _utils.pickDataProps)(props)), children);
};

var AppLayoutMainSidebarBase = function AppLayoutMainSidebarBase(_ref3) {
  var children = _ref3.children,
      props = (0, _objectWithoutProperties2.default)(_ref3, _excluded3);
  return (0, _core.jsx)(_GridItem.default, (0, _extends2.default)({
    lg: 4,
    md: 3,
    sm: _constants.GRID_COLUMNS.sm
  }, (0, _utils.pickDataProps)(props)), children);
};

var AppLayoutMain = (0, _composeStencilComponent.composeStencilComponent)({
  baseComponent: AppLayoutMainBase,
  displayName: 'AppLayoutMain',
  description: 'Main element to wrap page content and sidebar area.',
  propTypes: _objectSpread({
    children: _stencilReactDesc.PropTypes.node.description('Accepts <AppLayoutMainContent> and <AppLayoutMainSidebar> components as children'),
    size: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.AppLayoutMainSize)).description('Sets pre-defined sizes for the container')
  }, (0, _utils.omit)(_Flex.default.describedPropTypes, ['flexDirection', 'columnGap', 'flexWrap', 'maxWidth', 'width', 'margin'])),
  defaultProps: {
    size: _interfaces.AppLayoutMainSize.Large
  }
});
exports.AppLayoutMain = AppLayoutMain;
var AppLayoutMainContent = (0, _composeStencilComponent.composeStencilComponent)({
  baseComponent: AppLayoutMainContentBase,
  displayName: 'AppLayoutMainContent',
  description: 'Main content element to wrap <MainWithSkipLink>.'
});
exports.AppLayoutMainContent = AppLayoutMainContent;
var AppLayoutMainSidebar = (0, _composeStencilComponent.composeStencilComponent)({
  baseComponent: AppLayoutMainSidebarBase,
  displayName: 'AppLayoutMainSidebar',
  description: 'Main element to wrap page sidebar.'
});
exports.AppLayoutMainSidebar = AppLayoutMainSidebar;